<input class="checkBoxItem" name="chkBxEachItme" type="checkbox" [checked]="isSelected"
    id="booleanOption" [ngClass]="{'disabled opacity-60': isCheckboxDisabled, 'chk-ag-grid-guide':isFirstRow }"
    (input)="onClick($event)">